export const daoVotersMock = {
  "data": [
      {
          "address": "0x3dbadc86d19416ec16d81aa07ff2609e6241e7e9",
          "avatar": null,
          "ensName": "xielaoban.eth",
          "gScoreRanking": 33,
          "totalVotes": 165,
          "votesLost": 20,
          "votesWon": 139,
          "winPercentage": 84.24242424242424
      },
      {
          "address": "0x06c4865ab16c9c760622f19a313a2e637e2e66a2",
          "avatar": "https://ipfs.io/ipfs/Qmc7XEFBtaFnNLiU61L6uNt4m56S2kd1VhHRavAmjpf1hp",
          "ensName": "AEvolve",
          "gScoreRanking": 5,
          "totalVotes": 164,
          "votesLost": 23,
          "votesWon": 139,
          "winPercentage": 84.7560975609756
      },
      {
          "address": "0x0ff9b6ab6ec58ceb6d5ae8a1690dd5a0959ad002",
          "avatar": null,
          "ensName": "xinyubtc.eth",
          "gScoreRanking": 27,
          "totalVotes": 144,
          "votesLost": 13,
          "votesWon": 128,
          "winPercentage": 88.88888888888889
      },
      {
          "address": "0xd03ad690ed8065edfdc1e08197a3ebc71535a7ff",
          "avatar": null,
          "ensName": "daciv.eth",
          "gScoreRanking": 3,
          "totalVotes": 144,
          "votesLost": 14,
          "votesWon": 127,
          "winPercentage": 88.19444444444444
      },
      {
          "address": "0x344b1e4ac175f16d3ba40a688ca928e3768e275a",
          "avatar": null,
          "ensName": "866.ethscriptions.eth",
          "gScoreRanking": 26,
          "totalVotes": 143,
          "votesLost": 14,
          "votesWon": 126,
          "winPercentage": 88.11188811188812
      },
      {
          "address": "0x70ddb5abf21202602b57f4860ee1262a594a0086",
          "avatar": null,
          "ensName": "3668.ethscriptions.eth",
          "gScoreRanking": 21,
          "totalVotes": 142,
          "votesLost": 13,
          "votesWon": 126,
          "winPercentage": 88.73239436619718
      },
      {
          "address": "0xbda0136ea391e24a938793972726f8763150c7c3",
          "avatar": null,
          "ensName": "blockchian.eth",
          "gScoreRanking": 45,
          "totalVotes": 142,
          "votesLost": 13,
          "votesWon": 126,
          "winPercentage": 88.73239436619718
      },
      {
          "address": "0x97432c12ea8c957c3ae2d59c9953cf8df9cbc5b0",
          "avatar": null,
          "ensName": "universemoney.eth",
          "gScoreRanking": 19,
          "totalVotes": 136,
          "votesLost": 21,
          "votesWon": 113,
          "winPercentage": 83.08823529411765
      },
      {
          "address": "0x9ba6baa919bac9acd901df3bfde848fe006d3cae",
          "avatar": null,
          "ensName": "sznews.eth",
          "gScoreRanking": 41,
          "totalVotes": 130,
          "votesLost": 12,
          "votesWon": 116,
          "winPercentage": 89.23076923076924
      },
      {
          "address": "0xc97370f22ed5ac4c7b24a8e1ca9d81febb3b9457",
          "avatar": null,
          "ensName": "daohuas.eth",
          "gScoreRanking": 37,
          "totalVotes": 128,
          "votesLost": 8,
          "votesWon": 118,
          "winPercentage": 92.1875
      },
      {
          "address": "0x00432772ed25d4eb3c6eb26dc461239b35cf8760",
          "avatar": null,
          "ensName": "slmplex.eth",
          "gScoreRanking": 57,
          "totalVotes": 127,
          "votesLost": 9,
          "votesWon": 116,
          "winPercentage": 91.33858267716536
      },
      {
          "address": "0x1b5b4fcedf1252cd92496a2fd5c593b39ac49b01",
          "avatar": null,
          "ensName": "scryfans.eth",
          "gScoreRanking": 35,
          "totalVotes": 127,
          "votesLost": 9,
          "votesWon": 116,
          "winPercentage": 91.33858267716536
      },
      {
          "address": "0x2d5823e8e8b4dfbf599a97566ff2a121cc141d60",
          "avatar": null,
          "ensName": "orchidprotocol.eth",
          "gScoreRanking": 34,
          "totalVotes": 127,
          "votesLost": 9,
          "votesWon": 116,
          "winPercentage": 91.33858267716536
      },
      {
          "address": "0x76ac6ad4e4e7c2e0b4ceeb30745bd53df3a85774",
          "avatar": null,
          "ensName": "dextrysblockchain.eth",
          "gScoreRanking": 38,
          "totalVotes": 127,
          "votesLost": 9,
          "votesWon": 116,
          "winPercentage": 91.33858267716536
      },
      {
          "address": "0x0516cf37b67235e07af38ad8e388d0e68089b0f2",
          "avatar": null,
          "ensName": "soseth.eth",
          "gScoreRanking": 32,
          "totalVotes": 126,
          "votesLost": 11,
          "votesWon": 114,
          "winPercentage": 90.47619047619048
      },
      {
          "address": "0x972a8b7d891b88220780421fe4d11f174354ceed",
          "avatar": null,
          "ensName": "kongdata.eth",
          "gScoreRanking": 42,
          "totalVotes": 125,
          "votesLost": 8,
          "votesWon": 115,
          "winPercentage": 92
      },
      {
          "address": "0x707d306714ff28560f32bf9dae973bd33cd851c5",
          "avatar": null,
          "ensName": "8848community.eth",
          "gScoreRanking": 28,
          "totalVotes": 124,
          "votesLost": 9,
          "votesWon": 113,
          "winPercentage": 91.12903225806451
      },
      {
          "address": "0x7a3bdee62dd34fac317ae61cd8b3ba7c27ada145",
          "avatar": null,
          "ensName": "reblt.eth",
          "gScoreRanking": 44,
          "totalVotes": 124,
          "votesLost": 9,
          "votesWon": 113,
          "winPercentage": 91.12903225806451
      },
      {
          "address": "0x35e6fc00e3f190a8dfe15faa219368a01028ec14",
          "avatar": null,
          "ensName": "indigituseth.eth",
          "gScoreRanking": 59,
          "totalVotes": 124,
          "votesLost": 10,
          "votesWon": 112,
          "winPercentage": 90.32258064516128
      },
      {
          "address": "0xc85fcc44005a1d24142c6b347a0256b5e9306c10",
          "avatar": null,
          "ensName": "gzheth.eth",
          "gScoreRanking": 131,
          "totalVotes": 124,
          "votesLost": 6,
          "votesWon": 111,
          "winPercentage": 89.51612903225806
      },
      {
          "address": "0xfdab3be33284ef68442f55535ffc0b1fcbad2b62",
          "avatar": null,
          "ensName": "02468.eth",
          "gScoreRanking": 111,
          "totalVotes": 116,
          "votesLost": 12,
          "votesWon": 100,
          "winPercentage": 86.20689655172413
      },
      {
          "address": "0x23c4111d6f85de542dd8ad911c7c3cc66e98faa7",
          "avatar": null,
          "ensName": "fateswing.eth",
          "gScoreRanking": 760,
          "totalVotes": 113,
          "votesLost": 15,
          "votesWon": 97,
          "winPercentage": 85.84070796460178
      },
      {
          "address": "0xd31a84c20bc430ad75e6a1903e7ddbee52211072",
          "avatar": null,
          "ensName": "harusame.eth",
          "gScoreRanking": 10,
          "totalVotes": 111,
          "votesLost": 4,
          "votesWon": 102,
          "winPercentage": 91.8918918918919
      },
      {
          "address": "0x45452d8508356dc9619f23eab6932b4aab1946e6",
          "avatar": null,
          "ensName": "jackygao.eth",
          "gScoreRanking": 4242,
          "totalVotes": 110,
          "votesLost": 10,
          "votesWon": 99,
          "winPercentage": 90
      },
      {
          "address": "0x2fc3fd7c06adfc48736122ea33820038cc16dcdb",
          "avatar": null,
          "ensName": "velr.eth",
          "gScoreRanking": 1470,
          "totalVotes": 109,
          "votesLost": 14,
          "votesWon": 93,
          "winPercentage": 85.3211009174312
      },
      {
          "address": "0x839395e20bbb182fa440d08f850e6c7a8f6f0780",
          "avatar": "eip155:1/erc721:0xf5918382dd20ecba89747c50f80fb7f9f1e0524c/691",
          "ensName": "Griff Green",
          "gScoreRanking": 118,
          "totalVotes": 109,
          "votesLost": 27,
          "votesWon": 79,
          "winPercentage": 72.47706422018348
      },
      {
          "address": "0xbdcee87119265fc0ec27a3113efc3fbbb90d4d7b",
          "avatar": null,
          "ensName": "jbeic.eth",
          "gScoreRanking": 9669,
          "totalVotes": 108,
          "votesLost": 11,
          "votesWon": 96,
          "winPercentage": 88.88888888888889
      },
      {
          "address": "0xb89b619e3f6c35019d4be83e92e99e809af8ecb3",
          "avatar": null,
          "ensName": "nancysun.eth",
          "gScoreRanking": 5241,
          "totalVotes": 105,
          "votesLost": 8,
          "votesWon": 96,
          "winPercentage": 91.42857142857143
      },
      {
          "address": "0x88f659b4b6d5614b991c6404b34f821e10390ec0",
          "avatar": null,
          "ensName": "jt603.eth",
          "gScoreRanking": 2,
          "totalVotes": 104,
          "votesLost": 13,
          "votesWon": 86,
          "winPercentage": 82.6923076923077
      },
      {
          "address": "0xc2e2b715d9e302947ec7e312fd2384b5a1296099",
          "avatar": null,
          "ensName": "kbw.eth",
          "gScoreRanking": 8899,
          "totalVotes": 104,
          "votesLost": 20,
          "votesWon": 80,
          "winPercentage": 76.92307692307693
      },
      {
          "address": "0xd39ea6043d1fa03f5be2beb2cfe65faa4ef0e595",
          "avatar": null,
          "ensName": "mrblue88.eth",
          "gScoreRanking": 513,
          "totalVotes": 103,
          "votesLost": 15,
          "votesWon": 86,
          "winPercentage": 83.49514563106796
      },
      {
          "address": "0xc0882631627786eea84a851f66cdd1c0a070ea28",
          "avatar": null,
          "ensName": "filv85.eth",
          "gScoreRanking": 29,
          "totalVotes": 102,
          "votesLost": 7,
          "votesWon": 85,
          "winPercentage": 83.33333333333334
      },
      {
          "address": "0x8eef779818afa953b0652e45438423ebe089f55a",
          "avatar": null,
          "ensName": "souluv7.eth",
          "gScoreRanking": 16,
          "totalVotes": 100,
          "votesLost": 10,
          "votesWon": 85,
          "winPercentage": 85
      },
      {
          "address": "0x1684c382352fa8992e2d12264b08cbfd8e06b7b1",
          "avatar": null,
          "ensName": "yangi541999.eth",
          "gScoreRanking": 186,
          "totalVotes": 99,
          "votesLost": 6,
          "votesWon": 90,
          "winPercentage": 90.9090909090909
      },
      {
          "address": "0x5bca305df5b8446546224d7e548ef4e681eacfc9",
          "avatar": null,
          "ensName": "btcdot.eth",
          "gScoreRanking": 487,
          "totalVotes": 99,
          "votesLost": 11,
          "votesWon": 80,
          "winPercentage": 80.8080808080808
      },
      {
          "address": "0x48a9789428f2067338d02b1ef3612df64f05feb7",
          "avatar": "https://koi.rocks/content-detail/punM22h_1Dst35UeYq088iJGiGKPAWgLFSt9iH_3kp4?t=749855.4981288316",
          "ensName": "liuchaojin.eth",
          "gScoreRanking": 227,
          "totalVotes": 98,
          "votesLost": 16,
          "votesWon": 80,
          "winPercentage": 81.63265306122449
      },
      {
          "address": "0xd91a53803dffef52d4f277e55aa97ad35442a6ff",
          "avatar": null,
          "ensName": "lexx77.eth",
          "gScoreRanking": 251,
          "totalVotes": 98,
          "votesLost": 12,
          "votesWon": 72,
          "winPercentage": 73.46938775510205
      },
      {
          "address": "0x23fb34f91ce9dc6d8b0051baaba39c16a1352222",
          "avatar": null,
          "ensName": "3nation.eth",
          "gScoreRanking": 176,
          "totalVotes": 97,
          "votesLost": 14,
          "votesWon": 82,
          "winPercentage": 84.5360824742268
      },
      {
          "address": "0x3f5d2058971dfd0103e3bf5e423620b5a42db357",
          "avatar": null,
          "ensName": "3people.eth",
          "gScoreRanking": 15,
          "totalVotes": 96,
          "votesLost": 11,
          "votesWon": 83,
          "winPercentage": 86.45833333333334
      },
      {
          "address": "0x4d477f1aabcfc2fc3fc9b802e861c013e0123ad9",
          "avatar": null,
          "ensName": "wzrdcat.eth",
          "gScoreRanking": 46,
          "totalVotes": 96,
          "votesLost": 13,
          "votesWon": 80,
          "winPercentage": 83.33333333333334
      },
      {
          "address": "0x111ae4d8db445c46b4c342abbbb508519275d3c3",
          "avatar": null,
          "ensName": "datudou.eth",
          "gScoreRanking": 7027,
          "totalVotes": 95,
          "votesLost": 8,
          "votesWon": 86,
          "winPercentage": 90.52631578947368
      },
      {
          "address": "0xdd7724eff52c6ec5f2f7649eadd5025d890b3690",
          "avatar": null,
          "ensName": "scrszjzzq.eth",
          "gScoreRanking": 164,
          "totalVotes": 94,
          "votesLost": 5,
          "votesWon": 87,
          "winPercentage": 92.5531914893617
      },
      {
          "address": "0x9a2a0b906b6aa0ff5882b0feb9240a6749051979",
          "avatar": null,
          "ensName": "1btc2eth.eth",
          "gScoreRanking": 263,
          "totalVotes": 94,
          "votesLost": 7,
          "votesWon": 85,
          "winPercentage": 90.42553191489363
      },
      {
          "address": "0xbd95c7ce1c6fca2ce0b7c1b86f79dee0be5db7c8",
          "avatar": null,
          "ensName": "yangi541888.eth",
          "gScoreRanking": 297,
          "totalVotes": 94,
          "votesLost": 6,
          "votesWon": 85,
          "winPercentage": 90.42553191489363
      },
      {
          "address": "0x2c11ae904565fa3f47ac785860f5ec8c0368258c",
          "avatar": null,
          "ensName": "gzhcoin.eth",
          "gScoreRanking": 165,
          "totalVotes": 94,
          "votesLost": 9,
          "votesWon": 83,
          "winPercentage": 88.29787234042553
      },
      {
          "address": "0x472f916934161be833e924da2f31b8100f321ed1",
          "avatar": null,
          "ensName": "19451024.eth",
          "gScoreRanking": 780,
          "totalVotes": 94,
          "votesLost": 15,
          "votesWon": 78,
          "winPercentage": 82.97872340425532
      },
      {
          "address": "0x875bde4c417e22035c03bac45bb953d8000aba70",
          "avatar": null,
          "ensName": "liveforever227.eth",
          "gScoreRanking": 322,
          "totalVotes": 94,
          "votesLost": 15,
          "votesWon": 77,
          "winPercentage": 81.91489361702128
      },
      {
          "address": "0xc5f705ca8f70acc5f3d3db9636558102f528a475",
          "avatar": null,
          "ensName": "alex-4135.eth",
          "gScoreRanking": 1,
          "totalVotes": 94,
          "votesLost": 8,
          "votesWon": 76,
          "winPercentage": 80.85106382978722
      },
      {
          "address": "0xac236ea8ed1c73a83b5a10d17988028fec528f59",
          "avatar": null,
          "ensName": "neeer.eth",
          "gScoreRanking": 63,
          "totalVotes": 94,
          "votesLost": 7,
          "votesWon": 73,
          "winPercentage": 77.6595744680851
      },
      {
          "address": "0xba3d4228b2fc5b6751eeece88eae2ebbb8008f42",
          "avatar": null,
          "ensName": "snaphshot.eth",
          "gScoreRanking": 365,
          "totalVotes": 93,
          "votesLost": 7,
          "votesWon": 84,
          "winPercentage": 90.32258064516128
      },
      {
          "address": "0x0c1633e0ba164a9def56d86d7c46afcbe4d28a77",
          "avatar": null,
          "ensName": "xoradaka.eth",
          "gScoreRanking": 4867,
          "totalVotes": 93,
          "votesLost": 14,
          "votesWon": 75,
          "winPercentage": 80.64516129032258
      },
      {
          "address": "0xd2f1ce1a5fb4a1fbe2c6c646b1c1212ec5b0752e",
          "avatar": null,
          "ensName": "grinlandiya.eth",
          "gScoreRanking": 256,
          "totalVotes": 93,
          "votesLost": 8,
          "votesWon": 75,
          "winPercentage": 80.64516129032258
      },
      {
          "address": "0x696d181a7961ee66c42f1ebeddc0b48b106c45ad",
          "avatar": null,
          "ensName": "vicky77.eth",
          "gScoreRanking": 446,
          "totalVotes": 92,
          "votesLost": 6,
          "votesWon": 84,
          "winPercentage": 91.30434782608695
      },
      {
          "address": "0xc134f280c35dfd5ccd47ea1584e987ab64389fc6",
          "avatar": null,
          "ensName": "335201.eth",
          "gScoreRanking": 2066,
          "totalVotes": 91,
          "votesLost": 6,
          "votesWon": 84,
          "winPercentage": 92.3076923076923
      },
      {
          "address": "0xabe3496fa08355cf4a3cf4772053615396a8e4e9",
          "avatar": null,
          "ensName": "mrk889.eth",
          "gScoreRanking": 664,
          "totalVotes": 90,
          "votesLost": 8,
          "votesWon": 79,
          "winPercentage": 87.77777777777777
      },
      {
          "address": "0xeab804590011d0650fcb6c4da1870c6e9ca062d1",
          "avatar": null,
          "ensName": "croth.eth",
          "gScoreRanking": 99,
          "totalVotes": 90,
          "votesLost": 7,
          "votesWon": 79,
          "winPercentage": 87.77777777777777
      },
      {
          "address": "0x64b5f9dd6f23269b966a4c3717e150a6dd264851",
          "avatar": null,
          "ensName": "kunkun.eth",
          "gScoreRanking": 938,
          "totalVotes": 90,
          "votesLost": 10,
          "votesWon": 78,
          "winPercentage": 86.66666666666667
      },
      {
          "address": "0x29c2fca1b13efb25f37fe128a34c55eee763f143",
          "avatar": null,
          "ensName": "jup1ter.eth",
          "gScoreRanking": 788,
          "totalVotes": 90,
          "votesLost": 11,
          "votesWon": 75,
          "winPercentage": 83.33333333333334
      },
      {
          "address": "0xcd0d967449430caaabda422af22f64254c3f1168",
          "avatar": null,
          "ensName": "shardeum.eth",
          "gScoreRanking": 306,
          "totalVotes": 90,
          "votesLost": 9,
          "votesWon": 74,
          "winPercentage": 82.22222222222221
      },
      {
          "address": "0xff994acc57744b8f35fa7ead0af0495426308416",
          "avatar": null,
          "ensName": "dennizg.eth",
          "gScoreRanking": 158,
          "totalVotes": 90,
          "votesLost": 9,
          "votesWon": 74,
          "winPercentage": 82.22222222222221
      },
      {
          "address": "0x50b68702548fd2bfde1c4c02129cb2ce7067b2c4",
          "avatar": null,
          "ensName": "ver89.eth",
          "gScoreRanking": 380,
          "totalVotes": 90,
          "votesLost": 6,
          "votesWon": 73,
          "winPercentage": 81.11111111111111
      },
      {
          "address": "0xe99284ca6742f3d539da5e7407997744059bd620",
          "avatar": null,
          "ensName": null,
          "gScoreRanking": 171,
          "totalVotes": 90,
          "votesLost": 16,
          "votesWon": 69,
          "winPercentage": 76.66666666666667
      },
      {
          "address": "0x809f5eff8cd81944220f02e12ba4543cb01b54ee",
          "avatar": null,
          "ensName": "yuriy74.eth",
          "gScoreRanking": 371,
          "totalVotes": 90,
          "votesLost": 42,
          "votesWon": 43,
          "winPercentage": 47.77777777777778
      },
      {
          "address": "0x1f8231ef50e99d361b5252a24ec2ec44285367e1",
          "avatar": null,
          "ensName": "denispro2015.eth",
          "gScoreRanking": 53,
          "totalVotes": 89,
          "votesLost": 5,
          "votesWon": 76,
          "winPercentage": 85.39325842696628
      },
      {
          "address": "0xacc8b08359f6bf6a5a4a2eda056ade309cc0c716",
          "avatar": null,
          "ensName": "viks29.eth",
          "gScoreRanking": 1630,
          "totalVotes": 88,
          "votesLost": 6,
          "votesWon": 76,
          "winPercentage": 86.36363636363636
      },
      {
          "address": "0x65ee472fa8a76555a1cb72510e3d1da5f1662214",
          "avatar": null,
          "ensName": "seymonk.eth",
          "gScoreRanking": 280,
          "totalVotes": 88,
          "votesLost": 10,
          "votesWon": 75,
          "winPercentage": 85.22727272727273
      },
      {
          "address": "0x3f7bed3d5745c2550f64aa97a4529406e555bce6",
          "avatar": null,
          "ensName": "stefneil.eth",
          "gScoreRanking": 1174,
          "totalVotes": 88,
          "votesLost": 12,
          "votesWon": 74,
          "winPercentage": 84.0909090909091
      },
      {
          "address": "0x5a75f64493e39a48dd005e3041b8eb5c75a025db",
          "avatar": null,
          "ensName": "entseland.eth",
          "gScoreRanking": 448,
          "totalVotes": 88,
          "votesLost": 11,
          "votesWon": 72,
          "winPercentage": 81.81818181818183
      },
      {
          "address": "0x7a7a7930d462b959e5d1b34b0a34ca2452dcb1ab",
          "avatar": null,
          "ensName": "rabbywallet.eth",
          "gScoreRanking": 110,
          "totalVotes": 88,
          "votesLost": 18,
          "votesWon": 68,
          "winPercentage": 77.27272727272727
      },
      {
          "address": "0xdc9c5e34959ec3643af1e1d34a83d6b251aab1ef",
          "avatar": null,
          "ensName": "yuva.eth",
          "gScoreRanking": 60,
          "totalVotes": 88,
          "votesLost": 7,
          "votesWon": 68,
          "winPercentage": 77.27272727272727
      },
      {
          "address": "0x618ee1b1276781cfc7180266aaa737ab8df48518",
          "avatar": null,
          "ensName": "pigame.eth",
          "gScoreRanking": 91,
          "totalVotes": 87,
          "votesLost": 9,
          "votesWon": 76,
          "winPercentage": 87.35632183908046
      },
      {
          "address": "0x281ad9f2138ec59c3a9e7e4c98728c93eed868af",
          "avatar": null,
          "ensName": "zolazzz.eth",
          "gScoreRanking": 67,
          "totalVotes": 87,
          "votesLost": 9,
          "votesWon": 76,
          "winPercentage": 87.35632183908046
      },
      {
          "address": "0x09ad31043b0b939576d5206b064ca1807c4160fd",
          "avatar": null,
          "ensName": "dumindu.eth",
          "gScoreRanking": 8,
          "totalVotes": 87,
          "votesLost": 8,
          "votesWon": 71,
          "winPercentage": 81.60919540229885
      },
      {
          "address": "0xa8f5f683d7c5cff64b030a8303a32e0fcacee18f",
          "avatar": null,
          "ensName": "donaldduckland2.eth",
          "gScoreRanking": 331,
          "totalVotes": 87,
          "votesLost": 15,
          "votesWon": 70,
          "winPercentage": 80.45977011494253
      },
      {
          "address": "0x04adcb18c1ebaf21018cef1a7d185d410ddd4df9",
          "avatar": null,
          "ensName": "xiao2.eth",
          "gScoreRanking": 140,
          "totalVotes": 87,
          "votesLost": 20,
          "votesWon": 65,
          "winPercentage": 74.71264367816092
      },
      {
          "address": "0xbb0244016a4dcb20c499b50e740083cfbb6c2f78",
          "avatar": null,
          "ensName": "chinakungfu.eth",
          "gScoreRanking": 154,
          "totalVotes": 86,
          "votesLost": 6,
          "votesWon": 79,
          "winPercentage": 91.86046511627907
      },
      {
          "address": "0x92a848b0a1e5a92a8abe5345ec21ef87d86797ac",
          "avatar": null,
          "ensName": "197912.eth",
          "gScoreRanking": 327,
          "totalVotes": 86,
          "votesLost": 6,
          "votesWon": 77,
          "winPercentage": 89.53488372093024
      },
      {
          "address": "0x48b576c87e788a762d6f95a456f2a39113b46950",
          "avatar": null,
          "ensName": "mydearmama.eth",
          "gScoreRanking": 78,
          "totalVotes": 86,
          "votesLost": 7,
          "votesWon": 77,
          "winPercentage": 89.53488372093024
      },
      {
          "address": "0x6cffce8a38d25d2fc0040ea5068a0b3a5fc08d2a",
          "avatar": null,
          "ensName": "cryptodsh.eth",
          "gScoreRanking": 551,
          "totalVotes": 86,
          "votesLost": 11,
          "votesWon": 75,
          "winPercentage": 87.20930232558139
      },
      {
          "address": "0xab7b49bacd43bd4cfa41433d477f690bb9e1fb26",
          "avatar": null,
          "ensName": "81899.eth",
          "gScoreRanking": 82,
          "totalVotes": 86,
          "votesLost": 8,
          "votesWon": 75,
          "winPercentage": 87.20930232558139
      },
      {
          "address": "0xbf760fd4535fb211e5c6881b28283b60d1a059bf",
          "avatar": null,
          "ensName": "aydj234.eth",
          "gScoreRanking": 481,
          "totalVotes": 86,
          "votesLost": 15,
          "votesWon": 70,
          "winPercentage": 81.3953488372093
      },
      {
          "address": "0x4b1f10157951a7b72640e5b33d53d9dbea049b2f",
          "avatar": null,
          "ensName": "imtokenofficial.eth",
          "gScoreRanking": 129,
          "totalVotes": 86,
          "votesLost": 18,
          "votesWon": 66,
          "winPercentage": 76.74418604651163
      },
      {
          "address": "0xfca6735ca9b80732fbb5fa46fe501bf3bdb1f961",
          "avatar": null,
          "ensName": "alexpoter.eth",
          "gScoreRanking": 786,
          "totalVotes": 86,
          "votesLost": 73,
          "votesWon": 9,
          "winPercentage": 10.465116279069768
      },
      {
          "address": "0xdcf081c99efd404bbb6e28d8f81899ab80ef2fd2",
          "avatar": null,
          "ensName": null,
          "gScoreRanking": 654,
          "totalVotes": 85,
          "votesLost": 13,
          "votesWon": 70,
          "winPercentage": 82.35294117647058
      },
      {
          "address": "0xe7cf8fce5e83e07e56e2ebfeb7651f459c47217b",
          "avatar": "https://ipfs.io/ipfs/QmSkcNYQ8et32QSFpU5tq3N7D62RD3ev4TxjBBeWnFV4GW",
          "ensName": "KingRF",
          "gScoreRanking": 2007,
          "totalVotes": 85,
          "votesLost": 13,
          "votesWon": 69,
          "winPercentage": 81.17647058823529
      },
      {
          "address": "0x13e65d6a92c092da14046c332a7c89e2f35cf317",
          "avatar": null,
          "ensName": "zkdog.eth",
          "gScoreRanking": 135,
          "totalVotes": 85,
          "votesLost": 16,
          "votesWon": 67,
          "winPercentage": 78.82352941176471
      },
      {
          "address": "0x2eeb17c2e810a80e76c37003f0540fd6c75dc236",
          "avatar": null,
          "ensName": "0xpip.eth",
          "gScoreRanking": 137,
          "totalVotes": 85,
          "votesLost": 16,
          "votesWon": 67,
          "winPercentage": 78.82352941176471
      },
      {
          "address": "0xaac186bda1edfe82698265f4e5dee822e2aa2ab5",
          "avatar": null,
          "ensName": "paypal3.eth",
          "gScoreRanking": 169,
          "totalVotes": 85,
          "votesLost": 20,
          "votesWon": 63,
          "winPercentage": 74.11764705882354
      },
      {
          "address": "0x54e250ea9b59f4d627b7c35570e7acd688916ba6",
          "avatar": null,
          "ensName": "supra93.eth",
          "gScoreRanking": 6060,
          "totalVotes": 84,
          "votesLost": 7,
          "votesWon": 75,
          "winPercentage": 89.28571428571429
      },
      {
          "address": "0xcc35cd400494097adb9aba66d9ae43a2aa3e04cc",
          "avatar": "https://twitter.com/moqiao5/status/1464807452860293120?s=10",
          "ensName": "brutuscasa.eth",
          "gScoreRanking": 2480,
          "totalVotes": 84,
          "votesLost": 3,
          "votesWon": 75,
          "winPercentage": 89.28571428571429
      },
      {
          "address": "0x0de92626498717585f06e5bf5b85a7a88872f5b3",
          "avatar": null,
          "ensName": "vleeth.eth",
          "gScoreRanking": 2079,
          "totalVotes": 84,
          "votesLost": 9,
          "votesWon": 74,
          "winPercentage": 88.09523809523809
      },
      {
          "address": "0x5823fce2cfe346e34fbcd710664ee42bfdb07036",
          "avatar": null,
          "ensName": "vlooe.eth",
          "gScoreRanking": 2702,
          "totalVotes": 84,
          "votesLost": 9,
          "votesWon": 74,
          "winPercentage": 88.09523809523809
      },
      {
          "address": "0x363abd787ffbb039a51716b756eceb46881788a8",
          "avatar": null,
          "ensName": "soolnew.eth",
          "gScoreRanking": 1438,
          "totalVotes": 84,
          "votesLost": 9,
          "votesWon": 74,
          "winPercentage": 88.09523809523809
      },
      {
          "address": "0xba8765802198e5c19f2ba8fe9b0da2b225927aaf",
          "avatar": null,
          "ensName": "canivete.eth",
          "gScoreRanking": 292,
          "totalVotes": 84,
          "votesLost": 10,
          "votesWon": 72,
          "winPercentage": 85.71428571428571
      },
      {
          "address": "0x8018f89db208ff70408d0f6079b50939fb11ee44",
          "avatar": null,
          "ensName": "albertkarimov.eth",
          "gScoreRanking": 496,
          "totalVotes": 84,
          "votesLost": 10,
          "votesWon": 71,
          "winPercentage": 84.52380952380952
      },
      {
          "address": "0xe7893673e4d73bf8573028ac7fe0163f3cb38461",
          "avatar": null,
          "ensName": "greatcash.eth",
          "gScoreRanking": 455,
          "totalVotes": 84,
          "votesLost": 13,
          "votesWon": 67,
          "winPercentage": 79.76190476190477
      },
      {
          "address": "0x9ec14a04cb7822b56bef9d46357604b6f3a673cc",
          "avatar": null,
          "ensName": "alexanderone.eth",
          "gScoreRanking": 368,
          "totalVotes": 84,
          "votesLost": 18,
          "votesWon": 64,
          "winPercentage": 76.19047619047619
      },
      {
          "address": "0xdf70127b89a6b6c6c8e241f1bb409a43c3d74845",
          "avatar": null,
          "ensName": "247loan.eth",
          "gScoreRanking": 159,
          "totalVotes": 84,
          "votesLost": 18,
          "votesWon": 64,
          "winPercentage": 76.19047619047619
      },
      {
          "address": "0x62bc8c095f122cadef3b263ebaaab9d51f06c94d",
          "avatar": null,
          "ensName": "johnydrama.eth",
          "gScoreRanking": 918,
          "totalVotes": 84,
          "votesLost": 10,
          "votesWon": 59,
          "winPercentage": 70.23809523809523
      },
      {
          "address": "0x524967e9db088db344ec6722cfd7e19d81be17cc",
          "avatar": null,
          "ensName": null,
          "gScoreRanking": 921,
          "totalVotes": 84,
          "votesLost": 12,
          "votesWon": 59,
          "winPercentage": 70.23809523809523
      }
  ]
};

export const daoProposersMock = {
  "data": [
      {
          "address": "0xc2e2b715d9e302947ec7e312fd2384b5a1296099",
          "avatar": null,
          "ensName": "kbw.eth",
          "gScoreRanking": 8899,
          "proposalsLost": 0,
          "proposalsWon": 3,
          "totalProposals": 22,
          "winPercentage": 13.636363636363635
      },
      {
          "address": "0x8f48282e50b0210bd7c7dd69c54205e98b9ef5d9",
          "avatar": null,
          "ensName": "coachj.eth",
          "gScoreRanking": 39457,
          "proposalsLost": 0,
          "proposalsWon": 2,
          "totalProposals": 19,
          "winPercentage": 10.526315789473683
      },
      {
          "address": "0xa53d1eed800bd55d15c01733c2647ac77017aaa8",
          "avatar": null,
          "ensName": null,
          "gScoreRanking": 103945,
          "proposalsLost": 0,
          "proposalsWon": 0,
          "totalProposals": 18,
          "winPercentage": 0
      },
      {
          "address": "0xae6ef687e55ccd6ec96d2bf6e67fa51819193afd",
          "avatar": null,
          "ensName": "shawn164.eth",
          "gScoreRanking": 19148,
          "proposalsLost": 0,
          "proposalsWon": 1,
          "totalProposals": 15,
          "winPercentage": 6.666666666666667
      },
      {
          "address": "0x0cf30daf2fb962ed1d5d19c97f5f6651f3b691c1",
          "avatar": null,
          "ensName": "fishbiscuit.eth",
          "gScoreRanking": 64539,
          "proposalsLost": 0,
          "proposalsWon": 2,
          "totalProposals": 7,
          "winPercentage": 28.57142857142857
      },
      {
          "address": "0xdfbecc0b4aef80b96da27ab483feb0892472eac2",
          "avatar": null,
          "ensName": "mathildadv.eth",
          "gScoreRanking": 65475,
          "proposalsLost": 1,
          "proposalsWon": 4,
          "totalProposals": 6,
          "winPercentage": 66.66666666666666
      },
      {
          "address": "0x7e052ef7b4bb7e5a45f331128afadb1e589deaf1",
          "avatar": "https://ipfs.io/ipfs/QmafqGXdHzJfTrsddjir6cBwgp9id96XwHwfabZf68231H",
          "ensName": "Kris Is",
          "gScoreRanking": 44068,
          "proposalsLost": 0,
          "proposalsWon": 4,
          "totalProposals": 6,
          "winPercentage": 66.66666666666666
      },
      {
          "address": "0x01cf9fd2efa5fdf178bd635c3e2adf25b2052712",
          "avatar": "https://ipfs.io/ipfs/Qmc1dp62qtQWoJHi5BzpcUVAr7FA6qv3BXT7nZ7wwMJhUj",
          "ensName": "Disruption Joe",
          "gScoreRanking": 5267,
          "proposalsLost": 0,
          "proposalsWon": 0,
          "totalProposals": 6,
          "winPercentage": 0
      },
      {
          "address": "0x5762f3074605df17aebe3f5bc8fc7f8702aca752",
          "avatar": null,
          "ensName": "daoplomats.eth",
          "gScoreRanking": 10955,
          "proposalsLost": 0,
          "proposalsWon": 0,
          "totalProposals": 6,
          "winPercentage": 0
      },
      {
          "address": "0x894aa5f1e45454677a8560dde3b45cb5c427ef92",
          "avatar": null,
          "ensName": "wombat.eth",
          "gScoreRanking": 117993,
          "proposalsLost": 0,
          "proposalsWon": 3,
          "totalProposals": 5,
          "winPercentage": 60
      },
      {
          "address": "0x2df9a188fbe231b0dc36d14aceb65defbb049479",
          "avatar": null,
          "ensName": "janineleger.eth",
          "gScoreRanking": 284982,
          "proposalsLost": 0,
          "proposalsWon": 3,
          "totalProposals": 4,
          "winPercentage": 75
      },
      {
          "address": "0x34aa3f359a9d614239015126635ce7732c18fdf3",
          "avatar": "https://ipfs.io/ipfs/QmNme3Lo9d11MbDShkEZyw1QAuwNtK4eyrxhEf14vSBRYs",
          "ensName": "Austin Griffith",
          "gScoreRanking": 50170,
          "proposalsLost": 0,
          "proposalsWon": 1,
          "totalProposals": 4,
          "winPercentage": 25
      },
      {
          "address": "0x7a45e23cbb7765900f02c54757498bef01c2b18f",
          "avatar": "eip155:1/erc721:0x8b13e88EAd7EF8075b58c94a7EB18A89FD729B18/55",
          "ensName": "coday.eth",
          "gScoreRanking": 67922,
          "proposalsLost": 0,
          "proposalsWon": 0,
          "totalProposals": 4,
          "winPercentage": 0
      },
      {
          "address": "0x616cad18642f45d3fa5fcaad0a2d81764a9cba84",
          "avatar": null,
          "ensName": "umarkhan.eth",
          "gScoreRanking": 346141,
          "proposalsLost": 0,
          "proposalsWon": 0,
          "totalProposals": 4,
          "winPercentage": 0
      },
      {
          "address": "0x54becc7560a7be76d72ed76a1f5fee6c5a2a7ab6",
          "avatar": "eip155:1/erc1155:0x495f947276749Ce646f68AC8c248420045cb7b5e/8112316025873927737505937898915153732580103913704334048512380366552194613249",
          "ensName": "Simona Pop",
          "gScoreRanking": 4394,
          "proposalsLost": 0,
          "proposalsWon": 2,
          "totalProposals": 3,
          "winPercentage": 66.66666666666666
      },
      {
          "address": "0x393bc37ea5493233d2bdc68fd59dd97ee01b18cf",
          "avatar": null,
          "ensName": "deltajuliet.eth",
          "gScoreRanking": 55798,
          "proposalsLost": 0,
          "proposalsWon": 1,
          "totalProposals": 3,
          "winPercentage": 33.33333333333333
      },
      {
          "address": "0x41dcf431be96a3d41ac6602ef23e6fd58e71a5be",
          "avatar": null,
          "ensName": null,
          "gScoreRanking": 1571978,
          "proposalsLost": 0,
          "proposalsWon": 0,
          "totalProposals": 3,
          "winPercentage": 0
      },
      {
          "address": "0xcb42ac441fcade3935243ea118701f39aa004486",
          "avatar": "https://ipfs.io/ipfs/QmbzduXLTNKC5ifrQMXfTmcFAo9yV83RtoGFXizSQFtCbj",
          "ensName": "Callum Gladstone",
          "gScoreRanking": 125041,
          "proposalsLost": 0,
          "proposalsWon": 0,
          "totalProposals": 3,
          "winPercentage": 0
      },
      {
          "address": "0x5ba02f4ff6af1d9d2af8774d10fd32eb57d4e2e6",
          "avatar": null,
          "ensName": "p1anck.eth",
          "gScoreRanking": 579240,
          "proposalsLost": 0,
          "proposalsWon": 2,
          "totalProposals": 2,
          "winPercentage": 100
      },
      {
          "address": "0x10d6d2e343281d388291a3e02f3293aaeda67178",
          "avatar": null,
          "ensName": "helloshreyas.eth",
          "gScoreRanking": 32094,
          "proposalsLost": 0,
          "proposalsWon": 2,
          "totalProposals": 2,
          "winPercentage": 100
      },
      {
          "address": "0x86d3ee9ff0983bc33b93cc8983371a500f873446",
          "avatar": null,
          "ensName": "androolloyd.eth",
          "gScoreRanking": 155641,
          "proposalsLost": 0,
          "proposalsWon": 1,
          "totalProposals": 2,
          "winPercentage": 50
      },
      {
          "address": "0xdaeb6e6b4fd8b283de327142914f936228b96bc7",
          "avatar": null,
          "ensName": "gitcoin.kevinolsen.eth",
          "gScoreRanking": 1949954,
          "proposalsLost": 0,
          "proposalsWon": 1,
          "totalProposals": 2,
          "winPercentage": 50
      },
      {
          "address": "0x66b1de0f14a0ce971f7f248415063d44caf19398",
          "avatar": "https://ipfs.io/ipfs/QmbK3qEYJCiyjUCjGpLLsk7bisfBXwNLr45HEPw3pvCtwf",
          "ensName": "Yalor",
          "gScoreRanking": 2214,
          "proposalsLost": 0,
          "proposalsWon": 0,
          "totalProposals": 2,
          "winPercentage": 0
      },
      {
          "address": "0x6bf1eba9740441d0a8822eda4e116a74f850d81b",
          "avatar": "https://discuss.ens.domains/user_avatar/discuss.ens.domains/phutchins/45/561_2.png",
          "ensName": "phutchins.eth",
          "gScoreRanking": 370252,
          "proposalsLost": 0,
          "proposalsWon": 0,
          "totalProposals": 2,
          "winPercentage": 0
      },
      {
          "address": "0x6f6313db2b2035e5c1049423a17fcef54dc487b7",
          "avatar": null,
          "ensName": null,
          "gScoreRanking": 612920,
          "proposalsLost": 0,
          "proposalsWon": 0,
          "totalProposals": 2,
          "winPercentage": 0
      },
      {
          "address": "0xa1f754340d4b2de34d6f0b33833a5b8f46b351ae",
          "avatar": null,
          "ensName": null,
          "gScoreRanking": 769185,
          "proposalsLost": 0,
          "proposalsWon": 0,
          "totalProposals": 2,
          "winPercentage": 0
      },
      {
          "address": "0xb41077b88ff9e42355fc2ffeaa1810560ac5f192",
          "avatar": null,
          "ensName": "heynate.eth",
          "gScoreRanking": 124445,
          "proposalsLost": 0,
          "proposalsWon": 1,
          "totalProposals": 1,
          "winPercentage": 100
      },
      {
          "address": "0x9c2fd95e1b8bd9be5612700b0b29c893fea417e1",
          "avatar": null,
          "ensName": "five",
          "gScoreRanking": 28465,
          "proposalsLost": 0,
          "proposalsWon": 1,
          "totalProposals": 1,
          "winPercentage": 100
      },
      {
          "address": "0x748df7c92687a7aca7c1ac81b1cdc2a3995581b9",
          "avatar": null,
          "ensName": "chayz.eth",
          "gScoreRanking": 1074540,
          "proposalsLost": 0,
          "proposalsWon": 1,
          "totalProposals": 1,
          "winPercentage": 100
      },
      {
          "address": "0x4be88f63f919324210ea3a2ccad4ff0734425f91",
          "avatar": null,
          "ensName": "kevinolsen.eth",
          "gScoreRanking": 109128,
          "proposalsLost": 0,
          "proposalsWon": 1,
          "totalProposals": 1,
          "winPercentage": 100
      },
      {
          "address": "0x4a5b536a613e69f43a52f6aa7a7f3765428329ad",
          "avatar": null,
          "ensName": "coinqt.eth",
          "gScoreRanking": 365867,
          "proposalsLost": 0,
          "proposalsWon": 1,
          "totalProposals": 1,
          "winPercentage": 100
      },
      {
          "address": "0xee0579b4c36fd52ec0a2b542fb801f136838b7f1",
          "avatar": null,
          "ensName": "quamtum.eth",
          "gScoreRanking": 126374,
          "proposalsLost": 0,
          "proposalsWon": 1,
          "totalProposals": 1,
          "winPercentage": 100
      },
      {
          "address": "0xc9a238405ef9d753d55ec1eb8f7a7b17b8d83e63",
          "avatar": null,
          "ensName": "Hux",
          "gScoreRanking": 637428,
          "proposalsLost": 0,
          "proposalsWon": 0,
          "totalProposals": 1,
          "winPercentage": 0
      },
      {
          "address": "0x0631581c7824ddeebc8d288e38ebded3c0ac1226",
          "avatar": null,
          "ensName": "xuebojie.eth",
          "gScoreRanking": 667003,
          "proposalsLost": 0,
          "proposalsWon": 0,
          "totalProposals": 1,
          "winPercentage": 0
      },
      {
          "address": "0x167a8aeefa9edd35d50029ba12c84336fccb2464",
          "avatar": null,
          "ensName": null,
          "gScoreRanking": 1591950,
          "proposalsLost": 0,
          "proposalsWon": 0,
          "totalProposals": 1,
          "winPercentage": 0
      },
      {
          "address": "0x27f4128205122af0ce0b87190d7986814969c494",
          "avatar": null,
          "ensName": "graf1312.eth",
          "gScoreRanking": 204458,
          "proposalsLost": 0,
          "proposalsWon": 0,
          "totalProposals": 1,
          "winPercentage": 0
      },
      {
          "address": "0x2b888954421b424c5d3d9ce9bb67c9bd47537d12",
          "avatar": "https://ipfs.io/ipfs/QmawqFbPYta6V1eCBFxnfdCqjJnZzKVrNpeBKb3P7YSmB8",
          "ensName": "Lefteris Karapetsas",
          "gScoreRanking": 358,
          "proposalsLost": 0,
          "proposalsWon": 0,
          "totalProposals": 1,
          "winPercentage": 0
      },
      {
          "address": "0x2cd8f7bcc7ea6bdb3b308ba661e445e7990cf114",
          "avatar": null,
          "ensName": "ognev.eth",
          "gScoreRanking": 440149,
          "proposalsLost": 0,
          "proposalsWon": 0,
          "totalProposals": 1,
          "winPercentage": 0
      },
      {
          "address": "0x37097bc551cb7f072790de0629c4c7be0320892a",
          "avatar": null,
          "ensName": null,
          "gScoreRanking": 2561276,
          "proposalsLost": 0,
          "proposalsWon": 0,
          "totalProposals": 1,
          "winPercentage": 0
      },
      {
          "address": "0x3880fe0bc8754807a01dfe943280817986945429",
          "avatar": null,
          "ensName": null,
          "gScoreRanking": 2235409,
          "proposalsLost": 0,
          "proposalsWon": 0,
          "totalProposals": 1,
          "winPercentage": 0
      },
      {
          "address": "0x43a70ab0d5beb7c09f974630fbc56e601f28aa32",
          "avatar": null,
          "ensName": "jodicee.eth",
          "gScoreRanking": 204529,
          "proposalsLost": 0,
          "proposalsWon": 0,
          "totalProposals": 1,
          "winPercentage": 0
      },
      {
          "address": "0x46ac0c9c530dc960a4df75b20b594fba243e5b7c",
          "avatar": null,
          "ensName": "xpunk.eth",
          "gScoreRanking": 22774,
          "proposalsLost": 0,
          "proposalsWon": 0,
          "totalProposals": 1,
          "winPercentage": 0
      },
      {
          "address": "0x56a717bb925e7afda0ef4c6563f21b52479e8901",
          "avatar": null,
          "ensName": null,
          "gScoreRanking": 2561276,
          "proposalsLost": 0,
          "proposalsWon": 0,
          "totalProposals": 1,
          "winPercentage": 0
      },
      {
          "address": "0x5a92731582fc2f0ca82f940cd75c268e0b3d18cc",
          "avatar": null,
          "ensName": null,
          "gScoreRanking": 685479,
          "proposalsLost": 0,
          "proposalsWon": 0,
          "totalProposals": 1,
          "winPercentage": 0
      },
      {
          "address": "0x5bfcb4be4d7b43437d5a0c57e908c048a4418390",
          "avatar": null,
          "ensName": "fireeyesdao.eth",
          "gScoreRanking": 15564,
          "proposalsLost": 0,
          "proposalsWon": 0,
          "totalProposals": 1,
          "winPercentage": 0
      },
      {
          "address": "0x683a78ba1f6b25e29fbbc9cd1bfa29a51520de84",
          "avatar": null,
          "ensName": null,
          "gScoreRanking": 142773,
          "proposalsLost": 0,
          "proposalsWon": 0,
          "totalProposals": 1,
          "winPercentage": 0
      },
      {
          "address": "0x69383d63813ef83d0abd9b42ef168bd04853a0b2",
          "avatar": null,
          "ensName": null,
          "gScoreRanking": 2235068,
          "proposalsLost": 0,
          "proposalsWon": 0,
          "totalProposals": 1,
          "winPercentage": 0
      },
      {
          "address": "0x722ce03c15670c313f9596544cdb582c19f810e2",
          "avatar": null,
          "ensName": null,
          "gScoreRanking": 1696712,
          "proposalsLost": 0,
          "proposalsWon": 0,
          "totalProposals": 1,
          "winPercentage": 0
      },
      {
          "address": "0x74b8c1abfbe1862182ea5f73211d24f2f035e1ef",
          "avatar": null,
          "ensName": null,
          "gScoreRanking": 1284429,
          "proposalsLost": 0,
          "proposalsWon": 0,
          "totalProposals": 1,
          "winPercentage": 0
      },
      {
          "address": "0x7bfaf4c59aa4f011672b8e77789e1eb41abd654d",
          "avatar": null,
          "ensName": "wschwab.eth",
          "gScoreRanking": 678686,
          "proposalsLost": 0,
          "proposalsWon": 0,
          "totalProposals": 1,
          "winPercentage": 0
      },
      {
          "address": "0x7ed3a2cf96b6419de99ce3c95768c74b85995adf",
          "avatar": null,
          "ensName": "janinegtc.eth",
          "gScoreRanking": 1991792,
          "proposalsLost": 0,
          "proposalsWon": 0,
          "totalProposals": 1,
          "winPercentage": 0
      },
      {
          "address": "0x809fa673fe2ab515faa168259cb14e2bedebf68e",
          "avatar": "https://pbs.twimg.com/profile_images/1454140957704822785/Vqq2f5an_400x400.jpg",
          "ensName": "Alex Van De Sande ",
          "gScoreRanking": 7922,
          "proposalsLost": 0,
          "proposalsWon": 0,
          "totalProposals": 1,
          "winPercentage": 0
      },
      {
          "address": "0x83108a0653a14eaeb8301e7b10a37cfac39c82f6",
          "avatar": null,
          "ensName": "jkd.eth",
          "gScoreRanking": 1603540,
          "proposalsLost": 0,
          "proposalsWon": 0,
          "totalProposals": 1,
          "winPercentage": 0
      },
      {
          "address": "0x8477981dbd957ae4c6a249544e43915218948404",
          "avatar": null,
          "ensName": "iopen.eth",
          "gScoreRanking": 34210,
          "proposalsLost": 0,
          "proposalsWon": 0,
          "totalProposals": 1,
          "winPercentage": 0
      },
      {
          "address": "0x89107899991647a7d1a0bf8333e2579750d81a83",
          "avatar": null,
          "ensName": null,
          "gScoreRanking": 856792,
          "proposalsLost": 0,
          "proposalsWon": 0,
          "totalProposals": 1,
          "winPercentage": 0
      },
      {
          "address": "0x8d07d225a769b7af3a923481e1fdf49180e6a265",
          "avatar": "https://ipfs.io/ipfs/QmTLKm4dx7KBPtyEnqppbABi4kg2afTeoKKLQPa8cjc8gj",
          "ensName": "monetsupply",
          "gScoreRanking": 293,
          "proposalsLost": 0,
          "proposalsWon": 0,
          "totalProposals": 1,
          "winPercentage": 0
      },
      {
          "address": "0xabf28f8d9adfb2255f4a059e37d3bce9104969db",
          "avatar": null,
          "ensName": "meglister.eth",
          "gScoreRanking": 40856,
          "proposalsLost": 0,
          "proposalsWon": 0,
          "totalProposals": 1,
          "winPercentage": 0
      },
      {
          "address": "0xc9dc3c79eaa2028fb1a75196fb130c7b3c4b0dca",
          "avatar": null,
          "ensName": null,
          "gScoreRanking": 471934,
          "proposalsLost": 0,
          "proposalsWon": 0,
          "totalProposals": 1,
          "winPercentage": 0
      },
      {
          "address": "0xcda094bf48988fa872f17d5581fb33280ce7b4d0",
          "avatar": null,
          "ensName": "andros.eth",
          "gScoreRanking": 1051509,
          "proposalsLost": 1,
          "proposalsWon": 0,
          "totalProposals": 1,
          "winPercentage": 0
      },
      {
          "address": "0xd0ef3a2ae7fb496c0897400f1be46693b6183b0a",
          "avatar": null,
          "ensName": "sidcode.eth",
          "gScoreRanking": 322537,
          "proposalsLost": 1,
          "proposalsWon": 0,
          "totalProposals": 1,
          "winPercentage": 0
      },
      {
          "address": "0xd3e6120db19a701abc40bae9614f3ca635abde88",
          "avatar": null,
          "ensName": null,
          "gScoreRanking": 645215,
          "proposalsLost": 0,
          "proposalsWon": 0,
          "totalProposals": 1,
          "winPercentage": 0
      },
      {
          "address": "0xdafa879f659bba79011130cfa6537ab3e1abdd97",
          "avatar": null,
          "ensName": "captain-y.eth",
          "gScoreRanking": 325382,
          "proposalsLost": 1,
          "proposalsWon": 0,
          "totalProposals": 1,
          "winPercentage": 0
      },
      {
          "address": "0xe60dc42fd35bca913c6c7ef00237e7e338318fd5",
          "avatar": null,
          "ensName": "yunior.eth",
          "gScoreRanking": 592092,
          "proposalsLost": 0,
          "proposalsWon": 0,
          "totalProposals": 1,
          "winPercentage": 0
      },
      {
          "address": "0xedac4928185f46854a7932b368891238c540068a",
          "avatar": null,
          "ensName": null,
          "gScoreRanking": 966575,
          "proposalsLost": 0,
          "proposalsWon": 0,
          "totalProposals": 1,
          "winPercentage": 0
      }
  ]
}